module.exports = __webpack_public_path__ + "static/img/51路.efa5fcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/51路.jpg
// module id = r9za
// module chunks = 2